import * as React from "react";

function Preview() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="white" />
      <circle cx="25" cy="25" r="25" fill="#0074BD" fillOpacity="0.25" />
      <path
        d="M31.625 11.5H19.375C17.4062 11.5 15.875 13.0859 15.875 15V36C15.875 37.9688 17.4062 39.5 19.375 39.5H31.625C33.5391 39.5 35.125 37.9688 35.125 36V15C35.125 13.0859 33.5391 11.5 31.625 11.5ZM32.5 36C32.5 36.4922 32.0625 36.875 31.625 36.875H19.375C18.8828 36.875 18.5 36.4922 18.5 36V15C18.5 14.5625 18.8828 14.125 19.375 14.125H31.625C32.0625 14.125 32.5 14.5625 32.5 15V36ZM27.25 33.375H23.75C23.2578 33.375 22.875 33.8125 22.875 34.25C22.875 34.7422 23.2578 35.125 23.75 35.125H27.25C27.6875 35.125 28.125 34.7422 28.125 34.25C28.125 33.8125 27.6875 33.375 27.25 33.375Z"
        fill="#0074BD"
      />
    </svg>
  );
}

export default Preview;
